import lazyLoading from "./lazyLoading";

export default {
  name: "documents",
  meta: {
    icon: "fa-file",
    expanded: false,
    label: "Documents",
    permissions: "list documents"
  },

  children: [
    {
      name: "list-documents",
      path: "/admin/documents/list",
      meta: {
        title: "Liste des documents",
        label: "Liste",
        isAdminStaff: true
      },
      component: lazyLoading("documents/DocumentList")
    }
  ]
};
